<h2 mat-dialog-title>Element löschen</h2>
<mat-dialog-content>
  <p>Möchten Sie das Element "{{ data.elementName }}" (ID: {{ data.elementId }}) wirklich löschen?</p>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-button (click)="dialogRef.close()">Abbrechen</button>
  <button mat-button [mat-dialog-close]="true" color="warn">Löschen</button>
</mat-dialog-actions>
